import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseGetByCabinetRequest, IBaseGetByProductRequest, IBaseGetBySlotRequest, IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { ICreateSlotProductRequest, IGetSlotProductResponse, IUpdateSlotProductRequest } from '../models/slot-product';


@Injectable({
  providedIn: 'root'
})
export class SlotProductService {

  constructor(private http: HttpClient) { }

  // Slot Product
  createSlotProduct(request: ICreateSlotProductRequest) {
    return this.http.post<IGetSlotProductResponse>(
      `${environment.baseUrl}/v1/slotProducts/createSlotProduct`,
      request
    )
  }

  getSlotProductsGlobal(request: IBaseSearchRequest){
    return this.http.post<IPagedResults<IGetSlotProductResponse[]>>(
      `${environment.baseUrl}/v1/slotProducts/searchSlotProductsGlobal`,
      request
    )
  }

  getSlotProductsBySlot(request: IBaseGetBySlotRequest){
    return this.http.post<IPagedResults<IGetSlotProductResponse[]>>(
      `${environment.baseUrl}/v1/slotProducts/searchSlotProductsBySlot`,
      request
    )
  }

  getSlotProductsByProduct(request: IBaseGetByProductRequest){
    return this.http.post<IPagedResults<IGetSlotProductResponse[]>>(
      `${environment.baseUrl}/v1/slotProducts/searchSlotProductsByProduct`,
      request
    )
  }

  getSlotProductById(id: string){
    return this.http.get<IGetSlotProductResponse>(
      `${environment.baseUrl}/v1/slotProducts/getSlotProduct/${id}`
    )
  }

  updateSlotProduct(request: IUpdateSlotProductRequest){
    return this.http.put<IGetSlotProductResponse>(
      `${environment.baseUrl}/v1/slotProducts/updateSlotProduct/${request.id}`,
      request
    )
  }

  deleteSlotProduct(id :string){
    return this.http.delete(
      `${environment.baseUrl}/v1/slotProducts/deleteSlotProduct/${id}`
    )
  }
}
